"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateSeparator = exports.testIds = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
require("moment/locale/de");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const moment_1 = tslib_1.__importDefault(require("moment"));
const useDateFormatter_1 = require("../../../util/useDateFormatter");
exports.testIds = {
    dateSeparator: 'activity_feed-item-date_seperator',
};
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    container: ({ hasPrevActivity }) => ({
        paddingBottom: theme.spacing(4),
        position: 'relative',
        paddingTop: hasPrevActivity ? theme.spacing(4) : theme.spacing(2),
        '&:before': {
            content: '""',
            height: 1,
            background: theme.palette.sidebar.default,
            left: 0,
            right: 0,
            position: 'absolute',
        },
    }),
    date: {
        background: theme.palette.sidebar.default,
        padding: theme.spacing(1, 2),
        borderRadius: 30,
        color: theme.palette.background.paper,
        position: 'relative',
    },
}));
const DateSeparator = ({ date, hasPrevActivity }) => {
    const { current, translate } = (0, frontend_infra_localisation_1.useI18n)();
    const { formatDateShort, formatDayDate } = (0, useDateFormatter_1.useDateFormatter)();
    const momentDate = (0, moment_1.default)(date);
    const dayDiff = momentDate.startOf('day').diff((0, moment_1.default)(moment_1.default.now()).startOf('day'), 'days');
    let separatorMsg;
    switch (dayDiff) {
        case 0:
            separatorMsg = `${translate('activity-feed_date_separator_today')}, ${formatDateShort(date)}`;
            break;
        case -1:
            separatorMsg = `${translate('activity-feed_date_separator_yesterday')}, ${formatDateShort(date)}`;
            break;
        default: {
            momentDate.locale(current);
            separatorMsg = formatDayDate(date);
        }
    }
    const classes = useStyles({ hasPrevActivity });
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { display: "flex", justifyContent: "center", alignItems: "center", className: classes.container, "data-testid": exports.testIds.dateSeparator, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "caption", className: classes.date, children: separatorMsg }) }));
};
exports.DateSeparator = DateSeparator;
//# sourceMappingURL=DateSeparator.js.map